import { render } from "./nonAgency.vue?vue&type=template&id=96920ee8&scoped=true"
import script from "./nonAgency.vue?vue&type=script&lang=js"
export * from "./nonAgency.vue?vue&type=script&lang=js"

import "./nonAgency.vue?vue&type=style&index=0&id=96920ee8&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96920ee8"]])

export default __exports__